import React, { useEffect, useState } from "react";
import { Typography, Grid, Box } from "@mui/material";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import { useProductContext } from "../../context/ProductContext";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { deleteDoc, doc, db, getDoc, setDoc } from "../../firebase";
import AdminReviewModal from "./AdminReviewModal";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

const Review = (props) => {
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;
  currentLocation = "KO";
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { t, i18n } = useTranslation();
  const {
    id,
    rating,
    name,
    title,
    review,
    imgs,
    uid,
    productId,
    link,
    productName,
    created,
    admin,
  } = props;

  console.log("id", id);
  const { products } = useProductContext();
  const [productIndex, setProductIndex] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [open2, setOpen2] = React.useState(false);
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const deleteReview = async () => {
    handleClose();

    await deleteDoc(doc(db, props.reviewDBName, id));

    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);

    console.log("docSnap", docSnap.data());

    if (docSnap.exists()) {
      const reviews = docSnap.data().reviews;

      const index = reviews.indexOf(props.reviewDBName + "");
      if (index > -1) {
        console.log("********~~~~~~~~~~ found the review");
        reviews.splice(index, 1); // 2nd parameter means remove one item only
      }
      // console.log(" NEw reviews", reviews);

      setDoc(docRef, { reviews: reviews }, { merge: true });
    } else {
    }

    window.location.reload();
  };

  useEffect(() => {
    let index;
    products.map((product, idx) => {
      if (product.productId === productId) {
        index = idx;
      }
    });
    setProductIndex(index);
  }, [productId]);

  console.log(productId);
  console.log(productId.substring(3));
  console.log("props.reviewDBName", props.reviewDBName);

  console.log("id", id);

  const [alert, setAlert] = useState("");
  const [textToReply, setTextToReply] = useState(admin);

  const reply = () => {
    //props.reviewDBName
    if (textToReply.length > 10) {
      const ref = doc(db, props.reviewDBName, id);
      setDoc(ref, { admin: textToReply }, { merge: true });
      setAlert("관리자의 답변을 저장했습니다.");
      setTimeout(() => {
        handleClose2();
        props.refresh();
      }, 2000);
    } else {
      setAlert("10글자 이상 남겨주세요.");
    }
  };

  return (
    <>
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open2}
          onClose={handleClose2}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ fontSize: "14px", fontWeight: 600 }}
          >
            이 사용 후기에 답변을 남겨주세요.
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mb: 2, color: "#153a5a", fontWeight: 600 }}>{alert}</Box>
            {alert === "관리자의 답변을 저장했습니다." ? null : (
              <TextField
                id="outlined-basic"
                variant="outlined"
                multiline
                rows={4}
                sx={{ width: "500px" }}
                value={textToReply}
                onChange={(e) => setTextToReply(e.target.value)}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ mb: "5px" }}>
            <Button onClick={handleClose2} variant="outlined">
              취소
            </Button>
            <Button onClick={reply} variant="outlined">
              답변 저장하기
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {t("Are you sure to delete this review?")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("This review will be deleted and can not be restored.")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              {t("Cancel")}
            </Button>
            <Button onClick={deleteReview} variant="outlined">
              {t("Delete Forever")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
          p: 2,
          pt: 4,
        }}
      >
        <Grid item md={1} sm={12}>
          {products.map((pro) => {
            if (productId.substring(3) === pro.productId) {
              return <img src={pro.img} width="50" alt="" />;
            }
          })}
        </Grid>
        <Grid
          item
          md={11}
          sm={12}
          sx={
            {
              // border: "1px solid black",
            }
          }
        >
          <Box sx={{ display: "flex" }}>
            <Rating
              name="text-feedback"
              value={rating}
              readOnly
              precision={0.5}
              emptyIcon={
                <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
              }
              sx={{
                paddingRight: "5px",
                position: "relative",
                left: "-3px",
                top: "-2px",
                // border: "1px solid black",
              }}
            />
            <AccountCircleSharpIcon sx={{ color: "gray" }} />
            &nbsp;
            <div
              style={{
                minWidth: "80px",
                fontSize: "14px",
                position: "relative",
                top: "-5px",
              }}
            >
              {name}
            </div>
            <Typography sx={{ paddingLeft: "5px", fontWeight: "bold" }}>
              {title} &nbsp;&nbsp;
            </Typography>
          </Box>

          <Box>
            <Box sx={{ color: "gray", position: "relative", top: "-10px" }}>
              {t("written at")}: &nbsp;
              {created?.toDate().toLocaleDateString("fr-CA", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}{" "}
              {created?.toDate().toLocaleTimeString("ko-KR")}
            </Box>
            <Box sx={{ position: "relative", top: "-16px" }}>{review}</Box>

            <AdminReviewModal imgs={imgs} title={title} review={review} />

            {admin && (
              <Box
                sx={{
                  fontSize: "13px",
                  backgroundColor: "white",
                  p: 1,
                  px: 3,
                  mb: 1,
                }}
              >
                <span style={{ fontWeight: 600 }}>관리자 댓글</span>: {admin}
              </Box>
            )}

            <Box
              className="pink_link"
              sx={{ display: "flex", fontSize: "14px" }}
            >
              <span style={{ cursor: "pointer" }} onClick={handleClickOpen}>
                {t("Remove this review")}
              </span>
              <Tooltip title="현재 답변이 있다면, 새로운 답변으로 교체 될 것입니다">
                <span
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={handleClickOpen2}
                >
                  답변 남기기/수정
                </span>
              </Tooltip>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Review;
